import React, { useEffect, useState } from 'react';
import {
  TabsContainer,
  Tabs,
  Tab,
  TabPanelsContainer,
  TabPanel,
  TabsOrientation
} from 'react-magma-dom';
import { useDispatch, useSelector } from 'react-redux';

import SelectedDatasetPreview from './components/SelectedDatasetPreview';
import CengageHub from './components/CengageHub';
import UploadComponent from './components/UploadUserComponent';

import { getTypeOfFrequencyDataSet } from 'calculators/dataset/frequencyTable';

import { isErrorTypeOfUploadDataset } from 'store/scenes/dataSet/selectors';

import { parseDatasetURL, getHubFilePath, getHubCSVFilePath } from 'utilities';
import UpdateColumnVariableComponent from './components/UpdateColumnVariableComponent';
import {
  setFileState,
  setRawDataset,
  getSelectedParameters,
  setFrequencyDatasetState,
  getFrequencyColumnHeaders,
  getFrequencyDataSetLength,
  getDataset
} from '../../store/dataset';

const Component = () => {
  const dataset = useSelector(state => getDataset(state));
  const frequencyDataSetLength = useSelector(state => getFrequencyDataSetLength(state));
  const columnHeader = useSelector(state => getFrequencyColumnHeaders(state));
  const parameters = useSelector(state => getSelectedParameters(state));
  const isErrorType = useSelector(state => isErrorTypeOfUploadDataset(state));
  const dispatch = useDispatch();

  const isContingencyDataSetType = frequencyDataSetLength === 2;
  const isFrequencyDataSetType = frequencyDataSetLength === 1;
  const isFrequencyTable = isContingencyDataSetType || isFrequencyDataSetType;
  const nameForColumns = columnHeader;

  const [activeIndex, setActiveIndex] = useState(dataset ? 1 : 0);
  const [defaultTypesVariables, setDefaultTypesVariables] = useState({});

  /* Why Hub Data is fetched here ?
  * Tab Components unmount and mount each tab panel
  * Resulting in Data fetch on every mount
  * To avoid multiple fetch, data is fetched here */
  const [hubData, setHubData] = useState([]);
  useEffect(() => {
    const filePathURL = getHubFilePath();
    fetch(filePathURL, { mode: 'cors' })
      .then(response => {
        return response.json();
      })
      .then(jsonData => {
        setHubData(jsonData.data);
      });
  }, []);


  const showSelectedDatasetTab = () => {
    setActiveIndex(1);
  };

  /* Case 1: Setting Dataset from HUB */
  const hubDataSetChangeHandler = (newFilePath, hubItem) => {
    const filePathURL = getHubCSVFilePath(newFilePath);

    parseDatasetURL(filePathURL, newDataset => {
      const { teaching_tag: teachingTag, nameOfHeaders, numericalVariable, categoricalVariable, name } = hubItem;
      const isFrequencyDataset = (teachingTag && teachingTag.indexOf('Frequency Table') >= 0);
      const isContingencyDataset = (teachingTag && teachingTag.indexOf('Contingency Table') >= 0);

      // regular dataset
      if (!isFrequencyDataset && !isContingencyDataset) {
        const defaultTypes = {
          numericalVariable: numericalVariable ? numericalVariable.split('|') : [],
          categoricalVariable: categoricalVariable ? categoricalVariable.split('|') : []
        };
        setDefaultTypesVariables(defaultTypes);
        dispatch(setRawDataset(newDataset, name));
        showSelectedDatasetTab();
        return;
      }

      const frequencyDatasetType = getTypeOfFrequencyDataSet(newDataset);
      if (!frequencyDatasetType) {
        dispatch(setRawDataset(newDataset, name));
        return;
      }

      let nameOfFrequencyColumns = '';
      if (isContingencyDataset) {
        if (nameOfHeaders) {
          nameOfFrequencyColumns = nameOfHeaders;
        } else {
          nameOfFrequencyColumns = 'Category';
        }
      }
      dispatch(setFrequencyDatasetState(newDataset, frequencyDatasetType, nameOfFrequencyColumns, name));
      showSelectedDatasetTab();
    });
  };

  /* Case 2: Setting Dataset from User Uploaded file */
  const fileChangeHandler = (newFile, datasetType) => {
    // reset default types for variables
    setDefaultTypesVariables({});
    dispatch(setFileState(newFile, datasetType, showSelectedDatasetTab));
  };

  /* Override React Magma Header spacing to match Uniformity in SALT*/
  return (
    <div className="page-main__indent">
      <TabsContainer activeIndex={activeIndex} style={{ flexWrap: 'nowrap' }}>
        <div className="dataset-leftPanel" >
          <div className="content-item">
            <h1 className="header-page">Dataset Source</h1>
            <Tabs
              aria-label="Dataset Hub Tabs"
              orientation={TabsOrientation.vertical}
              onChange={setActiveIndex}
              id="datasetTabs"
            >
              <Tab>Import Dataset</Tab>
              <Tab>Selected Dataset</Tab>
            </Tabs>
            {
              isContingencyDataSetType && activeIndex === 1 &&
              <UpdateColumnVariableComponent
                isContingencyTable={isContingencyDataSetType}
                dataSet={dataset}
              />
            }
            <UploadComponent
              isDataSet={!!dataset}
              isFrequencyTable={isFrequencyTable}
              activeIndex={activeIndex}
              defaultTypesVariables={defaultTypesVariables}
              fileChange={fileChangeHandler}
              isErrorType={isErrorType}
            />
          </div>
        </div>
        <TabPanelsContainer>
          <TabPanel style={{ padding: '15px' }}>
            <CengageHub data={hubData} onDataSetChange={hubDataSetChangeHandler} />
          </TabPanel>
          <TabPanel style={{ padding: '15px' }}>
            <SelectedDatasetPreview parameters={parameters} isFrequencyTable={isFrequencyDataSetType} isContingencyTable={isContingencyDataSetType} nameForColumns={nameForColumns} />
          </TabPanel>
        </TabPanelsContainer>
      </TabsContainer>
    </div>
  );
};

export default Component;
